import { Component, ViewEncapsulation, Input, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { WindowService } from 'src/shared/providers/window.service';

@Component({
    selector: 'tidy-card',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./card.component.scss'],
    template: `
    <section>
      <ng-content></ng-content>
    </section>
  `,
    standalone: false
})

export  class CardComponent implements OnInit {
  @Input() showArrow: boolean;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private windowService: WindowService
  ) {}

  ngOnInit() {
    const isSecondaryLayer = localStorage.getItem('isPrimaryLayer') === 'false' && this.windowService.isDesktopRes;
    if (isSecondaryLayer) {
      this.renderer.addClass(this.el.nativeElement, 'secondary-layer');
    }
  }
}
